import React, { FC, useCallback, useEffect, useMemo } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { generalSettingsLoading } from '../../../store/selectors'
import { tabList } from './tabList'
import { getGeneralSettingsRequest } from '../../../store/actions'
import { Loader } from '../../../components/Loader'
import { TabsComponent } from '../../../components/Tabs'
import { routes } from '../../../constants/routes'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    paddingTop: theme.spacing(6),
  },
  titleWrap: {
    gap: theme.spacing(2),
    alignItems: 'center',
    color: theme.palette.primary.light,
  },
  titleId: {
    fontSize: 20,
  },
  infoWrap: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
  },
  section: {
    width: '100%',
  },
}))

export const General: FC = () => {
  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()
  const { tab } = useParams<{ tab: string }>()

  const loading = useSelector(generalSettingsLoading)

  const activeTab = useMemo(() => {
    const currentTab = tabList.find((t) => t.slug === tab)
    return currentTab?.slug || tabList[0].slug
  }, [tab])

  const handleTabChange = useCallback(
    (key: string) => {
      history.push(`${routes.SETTINGS_GENERAL}/${key}`)
    },
    [history],
  )

  useEffect(() => {
    dispatch(getGeneralSettingsRequest())
  }, [dispatch])

  useEffect(() => {
    if (!tab) {
      history.push(`${routes.SETTINGS_GENERAL}/${activeTab}`)
    }
  }, [tab, history, activeTab])

  return (
    <Grid container className={classes.container}>
      <Grid container className={classes.titleWrap}>
        <Typography variant="h1">General</Typography>
      </Grid>
      {loading ? <Loader /> : <TabsComponent tabList={tabList} activeTab={activeTab} onChangeTab={handleTabChange} />}
    </Grid>
  )
}
